import { useTourStore } from '@/state/tour';
import { layersOf, resetLayers, type StationImpl } from '../types';
import { LayersPanel } from './Panel';

const clamp01 = (v: number) => Math.min(1, Math.max(0, v));

// Reveal stage over station time: edges while the storeys build up, flat IFC colours from 0.4,
// the material presets fading in from 0.7.
function revealAt(t: number): number {
  if (t < 0.4) return 0;
  return 1 + clamp01((t - 0.7) / 0.2);
}

export const intro: StationImpl = {
  pick: 'arch',
  enter({ layers, height }) {
    resetLayers(layers, height);
  },
  update({ t, layers, height }) {
    const build = clamp01(t / 0.4);
    const reveal = useTourStore.getState().reducedMotion ? 2 : revealAt(t);
    for (const h of layers.values()) {
      // Clip a hair below 0 when unbuilt so ground-level slabs vanish too.
      h.rig.setClipY(-0.75 + build * (height + 1.5));
      h.rig.setReveal(reveal);
    }
    for (const h of layersOf(layers, (d) => d === 'space')) h.rig.setVisible(false);
  },
  leave({ layers, height }) {
    resetLayers(layers, height);
  },
  Panel: LayersPanel,
};
